// extracted by mini-css-extract-plugin
export var grid = "_c-5";
export var layout = "_c-0";
export var leftColumn = "_c-1";
export var leftInner = "_c-2";
export var rightColumn = "_c-3";
export var rightInner = "_c-4";